<style>
  .el-table .warning-row {
    background: oldlace;
  }
  .el-table .success-row {
    background: #f0f9eb;
  }
  a {
    color: #333333;
    text-decoration: none;
  }
  a:hover{
    color: #1890ff;
    text-decoration: none;
  }
.hdNews {
  padding: 12px 24px;
  margin-bottom: 10px;
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1)
}
.content_body li {
  line-height: 28px;
  padding: 0 0 0 10px;
}
.clear {
  clear: both;
}
</style>
<template>
<div>
  <HeaderView></HeaderView>
  <NavigateView></NavigateView>
  <BannerView></BannerView>
    <div v-bind:style="{minHeight: height+'px'}" style="width: 980px; margin: 0 auto;" >
    <template>
      <div class="content_body">
        <el-breadcrumb separator-class="el-icon-arrow-right">
          <el-breadcrumb-item style="padding-top: 8px;">企业申报</el-breadcrumb-item>
          <el-breadcrumb-item style="padding-top: 8px;">申报工具下载</el-breadcrumb-item>
        </el-breadcrumb>
        <el-divider content-position="left"></el-divider>
        </div>
        <template>
          <el-alert title="提示" type="info" :closable="false">
            <p style="line-height: 26px; font-size: 13px; color: #333;">&emsp;&emsp;为方便各药品生产企业更好地参与鹰潭采购联盟药品统一目录带量采购，做好药品申报工作，根据「药品统一目录带量采购公告」所附目录中药品，编制申报数据文件。请各药品生产企业下载后填报，作为申报工具的数据来源。最终报价文件由申报工具制作生成！
            <!-- （<label style="color: red;">申报截止时间：{{form.expiryDateString}}</label>） -->
            </p>
          </el-alert>
          <br/>
          <el-alert title="说明文档下载" type="info" :closable="false">
            <p>&emsp;</p>
            <p>&emsp;&emsp;<a :href="form.noticeLink" target="_blank" style="font-size: 13px;"><i class="el-icon-download" type="primary" style="font-size: 14px; border: 1px solid #1890ff; color: #1890ff; border-radius: 3px; margin: 0 3px;"></i>&ensp;点我下载文档</a></p>
            <p>&emsp;</p>
          </el-alert>
          <br/>
          <el-alert title="申报工具下载" type="info" :closable="false">
            <p>&emsp;</p>
            <p>&emsp;&emsp;<a :href="form.toolsLink" target="_blank" style="font-size: 13px;"><i class="el-icon-download" type="primary" style="font-size: 14px; border: 1px solid #1890ff; color: #1890ff; border-radius: 3px; margin: 0 3px;"></i>&ensp;点我下载工具</a></p>
            <p>&emsp;</p>
          </el-alert>
          <br/>
        </template>
    </template>
    </div>

  <FooterView></FooterView>
</div>

</template>
<script>
  export default {
    name: 'downloadTools',
    data(){
      return {
        height: 0,
        captchaUrl: '',
        submitButtonLoading: false,
        form: {
          id: '', attachsName: '', attachsPath: '', disabled: false,
          companyType: 0, title: '', projectName: '', projectCode: '', noticeLink: '', toolsLink: '', expiryDate: null, expiryDateString: ''
        },
        businessConfig: {},
        liBackgroundImg: process.env.VUE_APP_API_URL + 'r/cms/www/default/img/index/li_bg.jpg',
      };
    },
    mounted(){
      // sessionStorage['/download'] = true;
      if(!sessionStorage[this.$route.path]){
        window.location.href = process.env.VUE_APP_API_URL;
      }
      //动态设置内容高度 让footer始终居底   header+footer的高度是100
      this.height = document.documentElement.clientHeight - 350;
      //监听浏览器窗口变化　
      window.onresize = ()=> {this.height = document.documentElement.clientHeight - 350}
    },
    created() {
      this.initView();
    },
    watch:{},
    methods: {
      initView(){
        setTimeout(() => {
          const self = this
          self.submitButtonLoading = true;
          //这里需要调整，疫苗配送企业的调表失效时间与生产企业不一致，暂时没有考虑配送
          self.getBusinessConfig({ stype: 'DECLARE' }).then(res => {
            self.handleBusinessConfig(res);
          //   return self.getUserAttachments({});
          // }).then(res => {
          //   self.handleUserAttachments(res);
          //   return self.getVaccineProduct();
          // }).then(res => {
          //   self.handleBusinessConfig(res);
          }).catch(err => {
            console.info(err);
          })
        }, 200)
      },
      getBusinessConfig: function(param){
        return new Promise(resolve => {
          this.$api.meetingApi.getBusinessConfig(param).then(res => {
            this.submitButtonLoading = false;
            if(res.status === 200){
              if(res.data.code === 200){
                resolve(JSON.parse(res.data.data));
              }else{
                this.$message({ message: res.data.data, offset: 200, type: 'error' });
              }
            }else{
              this.$message.error(`服务忙，请稍后再试`);
            }
          }).catch(error => {
            this.submitButtonLoading = false;
          });
        })
      },
      handleBusinessConfig: function(res){
        this.businessConfig = { ...res[0] }
        //console.log(`this.businessConfig =>`, this.businessConfig)
        const { step1, step2, step3, noticeLink, toolsLink, expiryDate } = { ...res[0] }
        this.form.title = step1;
        this.form.projectName = step2;
        this.form.projectCode = step3;
        this.form.noticeLink = noticeLink;
        this.form.toolsLink = toolsLink;
        this.form.expiryDate = new Date(expiryDate.time);
        this.form.expiryDateString = this.toDateString(expiryDate.time, 'yyyy年MM月dd日 HH时')
        console.log(this.form.expiryDateString)
      },
      handleClick(tab, event){
        if(this[event]){
          this[event].call(this, tab);
        }
      },
      getRowKeys(row) {
        return row.id
      },
      handlePagination(pageNo, pageSize, obj){
        if(this[obj] && typeof this[obj] !== 'function'){
          if(pageNo){
            this[obj].pageNo = pageNo;
          }
          if(pageSize){
            this[obj].pageSize = pageSize;
          }
          this[this[obj].fn] && this[this[obj].fn]();
        }
      },
      toDateString: function(time, format){
        let date = new Date(time || new Date())
        ,ymd = [this.digit(date.getFullYear(), 4), this.digit(date.getMonth() + 1), this.digit(date.getDate())]
        ,hms = [this.digit(date.getHours()), this.digit(date.getMinutes()), this.digit(date.getSeconds())];
        format = format || 'yyyy-MM-dd HH:mm:ss';
        return format.replace(/yyyy/g, ymd[0]).replace(/MM/g, ymd[1]).replace(/dd/g, ymd[2]).replace(/HH/g, hms[0]).replace(/mm/g, hms[1]).replace(/ss/g, hms[2]);
      },
      digit: function(num, length){
        var str = '';
        num = String(num);
        length = length || 2;
        for(var i = num.length; i < length; i++){
          str += '0';
        }
        return num < Math.pow(10, length) ? str + (num|0) : num;
      },
      clearValidate(formName){
        this.$refs[formName].clearValidate();
      },
      changeCaptcha: function() {
        this.captchaUrl = this.getCaptchaUrl();
      },
      getCaptchaUrl: function() {
        this.form.captcha = '';
        return process.env.VUE_APP_API_URL+'captcha.svl?d='+new Date().getTime()
      },
      goLogin() {
        this.$message({ message: '登录过期，请重新登录账户！', offset: 200, type: 'error' });
        setTimeout(() => {
          this.submitButtonLoading = false;
          window.location.href = process.env.VUE_APP_API_URL;
        }, 2000)
      }
    }
  }
</script>
<style>
  .el-dialog__footer {
    text-align: center;
  }
  .el-divider-horizontal {
    display: block;
    height: 1px;
    width: 100%;
    margin: 12px 0;
  }
  .upload-left{
    text-align: left;
  }

  .register-wrapper-div{
    padding-top:10px;
    width: 750px;
    margin: 0 auto;
    background-color: #f8f8f8;
  }
  .el-dialog__body {
    padding: 10px 20px;
  }
  .el-radio{
    margin-right: 0;
  }
  .el-checkbox{
    margin-right: 5px;
  }
  .el-radio--mini.is-bordered {
    margin: 2px 0;
  }
  .el-divider--horizontal {
    margin: 10px 0;
  }
  .el-collapse-item__content{
    padding-bottom: 10px;
  }
  .el-alert--info.is-light{
    width: auto;
    height: 65%;
    margin-right: 15px;
  }
  .el-tag--plain{
    width: 130px;
    text-align: center;
    border: 0px solid #fff;
  }
  .radio-br{
    width: 75%
  }
  .radio-auto{
    float: left;
    margin-right: 10px;
  }
  .assess-score {
    margin-right: 10px;
  }

</style>



// WEBPACK FOOTER //
// src/views/Declare/DownloadTools.vue